/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Policy_Destructive_Awaiting_MoreInputs */



/**
* | output |
* | --- |
* | "…and {count} more" |
*
* @param {Agent_Policy_Destructive_Awaiting_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_awaiting_more = /** @type {((inputs: Agent_Policy_Destructive_Awaiting_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Awaiting_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`…und ${i?.count} weitere`)
	return /** @type {LocalizedString} */ (`…and ${i?.count} more`)
});